import { JsonSchemaValidator } from "@common/json-schema-validator";
import { MixerConfig, MixerId, MixerPipeId } from "../../interface";
import { mixerConfig, mixerId, mixerPipeId } from "../../schema";

export class MixerPipeStopCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerPipeStopCmd.validationSchema()
  );

  constructor(readonly value: MixerPipeStop) {
    this.value = JsonSchemaValidator.assert(MixerPipeStopCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["mixerId", "mixerConfig", "mixerPipeId"],
      properties: {
        mixerId,
        mixerConfig,
        mixerPipeId
      },
      additionalProperties: false
    };
  }
}

interface MixerPipeStop {
  mixerId: MixerId;
  mixerConfig: MixerConfig;
  mixerPipeId: MixerPipeId;
}
